export default () => ({
    categories: [],
    currentCategory: ''
});
